import { styled } from '@mui/material/styles'
import {
  Paper,
  ToggleButtonGroup,
  toggleButtonGroupClasses,
  toggleButtonClasses,
  ToggleButton,
  lighten,
  Typography,
} from '@mui/material'

export const StyledPaper = styled(Paper)`
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.custom.gray4};
  padding: 0 2px;
`

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  & .${toggleButtonGroupClasses.grouped} {
    margin: 0;
    border: 0;
    border-radius: 6px;

    &.${toggleButtonGroupClasses.disabled} {
      border: 0;
    }
  }

  &
    .${toggleButtonGroupClasses.middleButton},&
    .${toggleButtonGroupClasses.lastButton} {
    margin-left: 2px;
    border-left: 0;
  }
`

export const StyledToggleButton = styled(ToggleButton)`
  height: 36px;
  min-width: 36px;
  background-color: transparent;
  color: ${({ theme }) => theme.palette.custom.blue2};
  text-transform: none;
  padding: 0 12px;

  &.${toggleButtonClasses.selected} {
    background-color: ${({ theme }) => theme.palette.custom.blue2};
    color: ${({ theme }) => theme.palette.custom.white};

    &:hover {
      background-color: ${({ theme }) =>
        lighten(theme.palette.custom.blue2, 0.1)};
    }
  }
`

export const StyledOption = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
`
